import React from 'react';

import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Container, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';

import { CUSTOMIZATION_PROP_TYPES } from './services/customization.service';
import FakturDownloadForm from './faktur-download-form';

const useStyles = makeStyles((theme) => ({
  header: {
    fontWeight: 550,
    textAlign: 'center'
  },
  subHeader: {
    textAlign: 'center',
    color: theme.palette.text.secondary
  }
}));

FakturDownloadPage.propTypes = CUSTOMIZATION_PROP_TYPES;

function FakturDownloadPage(props) {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { portalCustomization, isDefaultPage } = props;

  return (
    <Container>
      <Grid
        container={true}
        direction="column"
        justify="center"
        alignItems="center"
      >
        <Grid item={true} container={true} xs={6} spacing={5}>
          <Grid item={true} container={true} spacing={1} xs={12}>
            <Grid item={true} xs={12}>
              <Typography
                className={classes.header}
                variant="h5"
                component="h2"
              >
                Halaman Unduh Langsung eFaktur PDF
              </Typography>
            </Grid>
            <Grid item={true} xs={12}>
              <Typography
                className={classes.subHeader}
                variant="h6"
                component="h3"
              >
                Halaman Khusus:
              </Typography>
              <Typography
                className={classes.subHeader}
                variant="h6"
                component="h3"
                data-testid="customer-display-name"
              >
                {portalCustomization.customerDisplayName}
              </Typography>
            </Grid>
          </Grid>
          <Grid item={true} xs={12}>
            <FakturDownloadForm portalCustomization={portalCustomization} isDefaultPage={isDefaultPage} />
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}

export default FakturDownloadPage;
